import React, { createContext, useState, useContext, ReactNode } from 'react';

interface VersionInfoState {
  loadedGameDocumentVersion: string | null;
  setLoadedGameDocumentVersion: (info: string | null) => void;
}

const VersionInfoContext = createContext<VersionInfoState | undefined>(
  undefined
);

export const VersionInfoProvider: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  const [loadedGameDocumentVersion, setLoadedGameDocumentVersion] = useState<
    string | null
  >(null);

  const value = { loadedGameDocumentVersion, setLoadedGameDocumentVersion };

  return (
    <VersionInfoContext.Provider value={value}>
      {children}
    </VersionInfoContext.Provider>
  );
};

export const useVersionInfo = (): VersionInfoState => {
  const context = useContext(VersionInfoContext);
  if (context === undefined) {
    throw new Error('useVersionInfo must be used within a VersionInfoProvider');
  }
  return context;
};
